import { h, render } from 'vue'
import Toast from '~/components/Toast.vue'

export interface ToastOptions {
  message: string
  type?: 'success' | 'error' | 'warning' | 'info'
  duration?: number
}

export const useToast = () => {
  const show = (options: ToastOptions) => {
    // 创建容器
    const container = document.createElement('div')
    document.body.appendChild(container)

    // 创建 Toast 组件实例
    const vnode = h(Toast, {
      ...options,
      onVnodeMounted: () => {
        // Toast 显示后，在指定时间后移除
        setTimeout(() => {
          render(null, container)
          document.body.removeChild(container)
        }, options.duration || 3000)
      },
    })

    // 渲染组件
    render(vnode, container)
  }

  const success = (message: string, duration?: number) => {
    show({ message, type: 'success', duration })
  }

  const error = (message: string, duration?: number) => {
    show({ message, type: 'error', duration })
  }

  const warning = (message: string, duration?: number) => {
    show({ message, type: 'warning', duration })
  }

  const info = (message: string, duration?: number) => {
    show({ message, type: 'info', duration })
  }

  return {
    show,
    success,
    error,
    warning,
    info,
  }
}
